// eslint-disable-next-line import/prefer-default-export
export enum SolicitacaoChatAreaResponsavelEnum {
  agendamento = 'Agendamento',
  autorizacao = 'Autorizacao'
}
